// 按钮权限
export default {
  inserted(el, { arg }) {
    const buttons = el.__vue__.$route?.meta?.buttons
    if (!buttons?.find((btn) => btn.path === arg)) {
      el?.parentNode?.removeChild(el)
    }
  },
}
